import { render, staticRenderFns } from "./Shader.vue?vue&type=template&id=3c5e54be&scoped=true&"
import script from "./Shader.vue?vue&type=script&lang=js&"
export * from "./Shader.vue?vue&type=script&lang=js&"
import style0 from "./Shader.vue?vue&type=style&index=0&id=3c5e54be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e54be",
  null
  
)

export default component.exports